@if (financialAccount && financialAccount.state !== 'DELETED') {
  <div class="entity-actions">
    @if (financialAccount) {
      <button
        class="action-button action-button-edit"
        [disabled]="isLoading | accessControl | async"
        (click)="onEdit()"
        title="Update Financial Account"
      >
        <rkt-icon name="edit"></rkt-icon>
      </button>
    }
    @if (financialAccount && financialAccount.category !== 'INTEGRATED') {
      <button
        class="action-button action-button-delete"
        [disabled]="isLoading | accessControl | async"
        (click)="onRemove()"
        title="Remove Financial Account"
      >
        <rkt-icon name="trash"></rkt-icon>
      </button>
    }
    @if (!['SUSPENDED', 'PENDING'].includes(financialAccountState) && !isIntegratedCard) {
      <button
        class="action-button action-button-suspend"
        [disabled]="isLoading | accessControl | async"
        (click)="onStateChange()"
        title="Suspend Financial Account"
      >
        <rkt-icon name="suspend"></rkt-icon>
      </button>
    }
    @if (financialAccountState === 'SUSPENDED' && !isIntegratedCard) {
      <button
        class="action-button action-button-unsuspend"
        [disabled]="isLoading | accessControl | async"
        (click)="onStateChange()"
        title="Unsuspend Financial Account"
      >
        <rkt-icon name="resume"></rkt-icon>
      </button>
    }
  </div>
}
